import React from 'react';

const PrivacyPolicyView = () => {
    return (
        <div className="bg-white p-8 rounded-lg shadow-xl max-w-4xl mx-auto my-8">
            <h1 className="text-3xl font-bold text-sky-700 mb-6">Privacy Policy</h1>
            <p className="text-gray-500 mb-4 text-sm">Last Updated: June 2026</p>
            
            <div className="space-y-6 text-gray-700 leading-relaxed">
                <section>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">1. Information Collection</h2>
                    <p>We collect information you provide directly to us when you create an account, place an order, or upload a prescription. This includes your name, mobile number, address, and medical records provided in prescriptions.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">2. Use of Information</h2>
                    <p>We use your information to process orders, verify prescriptions, communicate with you about your health services, and improve our platform functionality.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">3. Data Security</h2>
                    <p>We implement appropriate technical and organizational measures to protect your personal data, especially sensitive health information contained in prescriptions.</p>
                </section>

                <section>
                    <h2 className="text-xl font-semibold text-gray-800 mb-2">4. Sharing of Information</h2>
                    <p>We do not sell your personal data. Information is shared only with our licensed pharmacists and delivery partners to fulfill your orders.</p>
                </section>
            </div>
        </div>
    );
};

export default PrivacyPolicyView;
